var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-unused-vars */
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import React from 'react';
function Alert(props) {
    return React.createElement(MuiAlert, __assign({ elevation: 6, variant: 'filled' }, props));
}
export var SnackbarComponent = function (props) {
    return (React.createElement(Snackbar, __assign({}, props, { onClose: function () { return props.onAlertClose(); } }),
        React.createElement(Alert, { onClose: function () { return props.onAlertClose(); }, severity: props.severity }, props.alertMessage)));
};
SnackbarComponent.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=SnackbarComponent.js.map